import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { SearchModalComponent } from './search-modal.component';

interface SearchOpts {
  title: string;
  message: string;
  cardTitle?: string;
  placeholder?: string;
}

@Injectable()
export class SearchModalController {
  constructor(private modalCtrl: ModalController) {}

  public async show(opts: SearchOpts): Promise<{ name?: string }> {
    const modal = await this.modalCtrl.create({
      component: SearchModalComponent,
      cssClass: 'search-modal',
      componentProps: {
        title: opts.title,
        message: opts.message,
        ...(opts.cardTitle && { cardTitle: opts.cardTitle }),
        ...(opts.placeholder && { placeholder: opts.placeholder }),
      },
    });
    await modal.present();
    const { data } = await modal.onDidDismiss();
    return data;
  }
}
